<template>
  <div class="dishes-selector-v4">
    <p
      v-if="isTitleVisible"
      class="dishes-selector-v4__title"
    >
      Блюд в день
    </p>
    <div class="dishes-selector-v4__buttons">
      <CoreButton
        v-for="(menuType, index) in sortedMenuTypes"
        :key="menuType.type"
        class="dishes-selector-v4__btn"
        w100
        :type="getButtonType(menuType)"
        @click="selectMenuType(menuType)"
      >
        <div>
          <div class="dishes-selector-v4__dishes-count">
            {{ menuType.byMealsLabelTitleMobile }}
          </div>
          <div
            class="dishes-selector-v4__dishes-text"
            :class="getTextClasses(menuType)"
          >
            {{ menuType.byMealsLabelSubtitleMobile }}
          </div>
        </div>
        <div
          v-if="isLightLabelVisible && index == 0"
          class="dishes-selector-v4__dishes-label"
        >
          Лайт
        </div>
      </CoreButton>
    </div>
  </div>
</template>

<script>
import CoreButton from '@/components/core/ui/CoreButton'
// constants
import {
  MEALS,
  MEDIUM,
} from '@/config/constants'

export default {
  name: 'DishesSelector',

  components: {
    CoreButton,
  },

  props: {
    isTitleVisible: {
      type: Boolean,
      default: true,
    },
    isLightLabelVisible: {
      type: Boolean,
      default: false,
    },
    menuTypes: {
      required: true,
      type: Array,
    },
    defaultMenuType: {
      type: String,
      default: '',
    },
  },

  emits: ['select'],

  data () {
    return {
      selectedMenuType: null,
    }
  },

  computed: {
    sortedMenuTypes () {
      const breakfasts = this.menuTypes.find((menuType) => this.isBreakfast(menuType))
      const withoutBreakfasts = this.menuTypes.filter((menuType) => !this.isBreakfast(menuType))

      if (breakfasts) {
        withoutBreakfasts.push(breakfasts)
      }

      return withoutBreakfasts
    },
  },

  watch: {
    $route: {
      handler (route, oldRoute) {
        if (route.params?.goal !== oldRoute.params?.goal) {
          this.selectMenuTypeByRoute()
        }
      },
      deep: true,
    },
  },

  mounted () {
    this.selectMenuTypeByRoute()
  },

  methods: {
    selectMenuTypeByRoute () {
      let menuTypeFromRoute = this.$route.params.plan
      if (!menuTypeFromRoute) {
        menuTypeFromRoute = this.defaultMenuType
      }
      const menuType = this.sortedMenuTypes.find((menuType) => menuType.type === menuTypeFromRoute)
      if (menuType) {
        this.selectedMenuType = menuType
      } else {
        this.selectedMenuType = this.sortedMenuTypes[0]
      }
      if (this.$route.params.goal === MEDIUM || this.$route.params.goal === MEALS) {
        this.$emit('select', this.selectedMenuType)
      }
    },

    isBreakfast (menuType) {
      return menuType.type.includes('breakfast')
    },

    getButtonType (menuType) {
      if (menuType.id === this.selectedMenuType?.id) {
        return 'from-var'
      }
      return 'white-grey'
    },

    selectMenuType (menuType) {
      this.selectedMenuType = menuType
      this.sendGTMMarkupEvent({
        block: 'new_order',
        element: 'menu',
        action: 'change',
      })
      this.$router.replace({
        ...this.$route,
        params: {
          ...this.$route.params,
          plan: menuType.type,
        },
      })
      this.$emit('select', menuType)
    },

    getTextClasses (menuType) {
      return {
        'dishes-selector-v4__dishes-text--active': this.selectedMenuType === menuType,
      }
    },
  },
}
</script>

<style lang="scss">
.dishes-selector-v4 {
  &__title {
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    padding-bottom: 16px;
  }

  &__buttons {
    display: flex;
    justify-content: space-between;
    column-gap: 8px;
  }

  &__btn {
    position: relative;
    min-height: 48px;
    border-radius: 16px;
    font-size: 12px;
    line-height: 14px;
    padding: 0;
    text-transform: none;
  }

  &__dishes-count {
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
  }

  &__dishes-text {
    color: map-get($colors, 'grey_40');

    &--active {
      color:  var(--color, map-get($colors, 'white'));
    }
  }
  &__dishes-label {
    position: absolute;
    top: -4px;
    right: -4px;
    padding: 4px 8px;
    background: map-get($colors, 'green_15');
    border-radius: 100px;
    color: map-get($colors, 'default');
    text-transform: uppercase;
    text-align: center;
    font-weight: 500;
    font-size: 8px;
    line-height: 8px;
    letter-spacing: .6px;
  }
}
</style>
